import { useState, useEffect } from 'react';
import { AxiosError } from 'axios';
import { BackendResponsePassportCheck, postPassportCheck } from '../../api/apiMethods';
import { sanitizeObject } from '~/utils';

interface UsePassportCheckProps {
	fileId: number;
	pageType: 'main' | 'registration';
	questionnaireUid: string;
	questionnaireType: 'ru_customer' | 'ru_partner';
	shouldFetch?: boolean;
}

interface UsePassportCheckResult {
	status: 'idle' | 'pending' | 'success' | 'reject' | 'warning';
	messages: string[];
	setStatus: (status: 'idle' | 'pending' | 'success' | 'reject' | 'warning') => void;
}

export const usePassportCheck = ({
	fileId,
	pageType,
	questionnaireUid,
	questionnaireType,
	shouldFetch = true,
}: UsePassportCheckProps): UsePassportCheckResult => {
	const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'reject' | 'warning'>('idle');
	const [messages, setMessages] = useState<string[]>([]);

	const [mockCountMain, setMockCountMain] = useState<number>(0);
	const [mockCountRegistration, setMockCountRegistration] = useState<number>(0);

	useEffect(() => {
		if (!fileId || !pageType || !questionnaireUid || !questionnaireType || !shouldFetch) {
			setStatus('idle');
			return;
		}

		const checkPassport = async () => {
			setStatus('pending');
			setMessages([]);

			try {
				// в старой реалзации скрыли этот блок и запрос не нужен. так как вводит пользователя в заблуждение

				// let response: BackendResponsePassportCheck;

				// const responsePostCheck = await postPassportCheck({
				// 	file_id: fileId,
				// 	page_type: pageType,
				// 	questionnaire_uid: questionnaireUid,
				// 	questionnaire_type: questionnaireType,
				// })
				// response = sanitizeObject(responsePostCheck.data);

				// const { success, data } = response;

				// setMessages(data);

				// if (success === 1) {
				// 	setStatus('success');
				// } else {
				// 	setStatus('reject');

				// 	questionnaireType === 'ru_customer' ? setMockCountMain(mockCountMain + 1) : setMockCountRegistration(mockCountRegistration + 1);
				// 	if (mockCountMain === 2) {
				// 		setStatus('warning');
				// 		setMessages(['Сверить данные паспорта не удалось, продолжайте заполнение анкеты. Менеджеры в ближайшее время свяжутся с Вами для уточнения данных.']);
				// 	}
				// }
			} catch (err) {
				const error = sanitizeObject(err);
				setStatus('reject');
				setMessages(
					error.response?.data?.data || ['Не удалось выполнить запрос к серверу']
				);
			}
		};

		checkPassport();
	}, [fileId, pageType, questionnaireUid, questionnaireType, shouldFetch]);

	return { status, setStatus, messages };
};
